import axios from 'src/config/axios.config';
import { API_ENDPOINTS } from 'src/config/api.config';
import { storage } from 'src/utils/storage';

interface User {
  id: string;
  name: string;
  username: string;
  accountNonExpired: boolean;
  isEnabled: boolean;
  accountNonLocked: boolean;
  credentialsNonExpired: boolean;
  authorities: string[];
}

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const token = storage.get('token');
    if (!token) {
      return null;
    }

    // Use the new /api/users/me endpoint that works for all authenticated users
    const response = await axios.get(`${API_ENDPOINTS.USERS}/me`);
    const userData = response.data;

    return {
      id: userData.id,
      name: userData.name,
      username: userData.username,
      accountNonExpired: userData.accountNonExpired,
      isEnabled: userData.enabled,
      accountNonLocked: userData.accountNonLocked,
      credentialsNonExpired: userData.credentialsNonExpired,
      authorities: userData.authorities
    };
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
}; 